import { Notices } from './Notices'
import './styles.modules.scss'

export default Notices
